// extracted by mini-css-extract-plugin
export default {"circular":"Qv0ktmOZzBKxrLM6tTuv","bounce":"Om9VsnIhm2pFyvmfE20v"};